// src/components/PeoplePlan/EmployeeManagement/WorkflowForms/DynamicWorkflowForm.js
import React from "react";
import styles from "./WorkflowForms.module.css";

const DynamicWorkflowForm = ({
  workflow,
  formData,
  formErrors,
  onFieldChange,
  storeList = [],
  dynamicOptions = null,
}) => {
  const renderField = (field) => {
    // Check conditional rendering
    if (field.condition) {
      const conditionValue = formData[field.condition.field];
      if (
        field.condition.notEquals &&
        conditionValue === field.condition.notEquals
      ) {
        return null;
      }
      if (field.condition.equals && conditionValue !== field.condition.equals) {
        return null;
      }
    }

    const error = formErrors[field.name];
    const value = formData[field.name] || "";

    switch (field.type) {
      case "text":
        return (
          <div key={field.name} className={styles.formField}>
            <label>{field.label}:</label>
            <input
              type="text"
              value={value || field.placeholder}
              readOnly={field.readonly}
              onChange={(e) =>
                !field.readonly && onFieldChange(field.name, e.target.value)
              }
              className={`${error ? styles.error : ""} ${
                field.readonly ? styles.readonly : ""
              }`}
              placeholder={field.placeholder}
            />
            {error && <p className={styles.errorText}>{error}</p>}
          </div>
        );

      case "select":
        const options =
          field.dynamicOptions && dynamicOptions?.[field.name]
            ? dynamicOptions[field.name]
            : field.options;

        return (
          <div key={field.name} className={styles.formField}>
            <label>{field.label}:</label>
            <select
              value={value}
              onChange={(e) => onFieldChange(field.name, e.target.value)}
              className={error ? styles.error : ""}
              disabled={field.readonly}
            >
              <option value="">Select an Option</option>
              {options &&
                options.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
            </select>
            {error && <p className={styles.errorText}>{error}</p>}
          </div>
        );

      case "store-select":
        return (
          <div key={field.name} className={styles.formField}>
            <label>{field.label}:</label>
            <select
              value={value}
              onChange={(e) => onFieldChange(field.name, e.target.value)}
              className={error ? styles.error : ""}
            >
              <option value="">Select a store</option>
              {storeList.map((store, idx) => (
                <option key={idx} value={store}>
                  {store}
                </option>
              ))}
            </select>
            {error && <p className={styles.errorText}>{error}</p>}
          </div>
        );

      case "number":
        return (
          <div key={field.name} className={styles.formField}>
            <label>{field.label}:</label>
            <input
              type="number"
              step={field.step || "1"}
              value={value}
              onChange={(e) => onFieldChange(field.name, e.target.value)}
              className={error ? styles.error : ""}
              readOnly={field.readonly}
            />
            {error && <p className={styles.errorText}>{error}</p>}
          </div>
        );

      case "date":
        return (
          <div key={field.name} className={styles.formField}>
            <label>{field.label}:</label>
            <input
              type="date"
              value={value}
              onChange={(e) => onFieldChange(field.name, e.target.value)}
              className={error ? styles.error : ""}
              readOnly={field.readonly}
            />
            {error && <p className={styles.errorText}>{error}</p>}
          </div>
        );

      case "datetime-local":
        return (
          <div key={field.name} className={styles.formField}>
            <label>{field.label}:</label>
            <input
              type="datetime-local"
              value={value}
              onChange={(e) => onFieldChange(field.name, e.target.value)}
              className={error ? styles.error : ""}
              readOnly={field.readonly}
            />
            {error && <p className={styles.errorText}>{error}</p>}
          </div>
        );

      case "textarea":
        return (
          <div key={field.name} className={styles.formField}>
            <label>{field.label}:</label>
            <div className={styles.textareaContainer}>
              <textarea
                value={value}
                onChange={(e) => onFieldChange(field.name, e.target.value)}
                maxLength={field.maxLength}
                placeholder={field.placeholder || ""}
                className={error ? styles.error : ""}
                readOnly={field.readonly}
              />
              {field.maxLength && (
                <span className={styles.charCounter}>
                  {value.length}/{field.maxLength}
                </span>
              )}
            </div>
            {error && <p className={styles.errorText}>{error}</p>}
          </div>
        );

      case "checkbox":
        return (
          <div key={field.name} className={styles.formField}>
            <div className={styles.checkboxContainer}>
              <input
                type="checkbox"
                id={field.name}
                checked={value === true || value === "true"}
                onChange={(e) => onFieldChange(field.name, e.target.checked)}
                className={error ? styles.error : ""}
                disabled={field.readonly}
              />
              <label htmlFor={field.name} className={styles.checkboxLabel}>
                {field.label}
              </label>
            </div>
            {error && <p className={styles.errorText}>{error}</p>}
          </div>
        );

      case "employee-select":
        return (
          <div key={field.name} className={styles.formField}>
            <label>{field.label}:</label>
            <input
              type="text"
              value={value || "Employee will be selected from table"}
              readOnly={true}
              className={`${error ? styles.error : ""} ${styles.readonly}`}
              placeholder={field.placeholder}
            />
            {error && <p className={styles.errorText}>{error}</p>}
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className={styles.workflowForm}>
      {workflow?.formFields?.map((field) => renderField(field))}
    </div>
  );
};

export default DynamicWorkflowForm;
